import type { SVGProps } from 'react';
export const FavouritesFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M9.74 15.94a.6.6 0 0 0 .52 0c.14-.08 1.82-1 3.47-2.44C15.37 12.06 17 10.1 17 7.9A3.9 3.9 0 0 0 13.1 4c-1.27 0-2.39.54-3.1 1.45A3.9 3.9 0 0 0 6.9 4 3.9 3.9 0 0 0 3 7.9c0 2.19 1.63 4.16 3.27 5.6q1.6 1.4 3.47 2.44" />
  </svg>
);
